import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import {
  LlmConfigFieldsFragment,
  LlmConversationMessagesFieldsFragment,
  LlmSummarizeResponseFieldsFragment,
} from './fragments';
import { LlmCreateFormulaTemplateFieldsFragment } from '../analysis/fragments';

export const LLM_UPDATE_API_CONFIG = gql`
  mutation llmUpdateApiConfig($input: LLmConfigInput!) {
    llmUpdateApiConfig(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...LlmConfigFields
      }
    }
  }
  ${ErrorFragment}
  ${LlmConfigFieldsFragment}
`;

export const LLM_SUMMARIZE_ENTITY = gql`
  mutation llmSummarizeEntity($input: LlmSummarizeInput!) {
    llmSummarizeEntity(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...LlmSummarizeResponseFields
      }
    }
  }
  ${ErrorFragment}
  ${LlmSummarizeResponseFieldsFragment}
`;

export const LLM_CREATE_FORMULA_TEMPLATE = gql`
  mutation llmCreateFormulaTemplate($input: LlmCreateFormulaTemplateInput!) {
    llmCreateFormulaTemplate(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...LlmCreateFormulaTemplateFields
      }
    }
  }
  ${ErrorFragment}
  ${LlmCreateFormulaTemplateFieldsFragment}
`;

// XXX these below are "debug" APIs for now

export const LLM_PROCESS_CONVERSATION_PROMPT = gql`
  mutation llmProcessConversationPrompt($input: LlmConversationPromptInput!) {
    llmProcessConversationPrompt(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...LlmConversationMessagesFields
      }
    }
  }
  ${ErrorFragment}
  ${LlmConversationMessagesFieldsFragment}
`;

export const LLM_RESET_CONVERSATION = gql`
  mutation llmResetConversation($input: LlmResetConversationInput!) {
    llmResetConversation(input: $input) {
      errors {
        ...ErrorFields
      }
      entity
    }
  }
  ${ErrorFragment}
`;
